import { EntityServiceAdapter, QueryParams, QueryResult } from '../../../types/baseExplorerConfig';
import { LightningEntity } from '../../../types/lightning';
import { lightningService } from '../../../services/lightningService';
import { translateParams } from './lightningParams';
import { objectToSearchParams } from '../baseExplorer/objectToSearchParams';
import { backendPage, pageHasMore } from '../../../utils/pagination';

export const lightningServiceAdapter: EntityServiceAdapter<LightningEntity> = {
  async fetchData(params: QueryParams): Promise<QueryResult<LightningEntity>> {
    try {
      const serviceParams: any = {
        ...backendPage(params),
        ...translateParams(params),
      };

      const response = await lightningService.fetchData(serviceParams);

      return {
        data: response.data.map((strike: any) => ({
          ...strike,
          _id: strike._id || String(strike.strikeId),
        })),
        total: response.total,
        page: response.page,
        limit: response.limit,
        hasMore: pageHasMore(response.page, response.limit, response.total),
      };
    } catch (error) {
      console.error('Lightning ServiceAdapter Error:', error);
      throw error;
    }
  },

  buildExportParams: (params: QueryParams) => objectToSearchParams(translateParams(params)),
};
